import styled from "styled-components";

export const Label = styled.label`
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  font-size: 0.9rem;
  font-weight: 500;
`;

export const LabelContainer = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 0.5rem;
`;

export const GenerateButton = styled.button`
  font-size: 0.9rem;
  font-weight: 500;
  text-decoration: underline;
  background-color: transparent;
  border: none;
  cursor: pointer;
`;

export const Input = styled.input`
  font-size: 1rem;
  padding: 0.5rem 0.5rem;
  border: 1px solid #393939;
`;